(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sp3019-complete-suit"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', () => {
    document.querySelectorAll('[data-complete-suit]').forEach((root) => {
      const jacket = root.querySelector('[data-suit-jacket]');
      const pants = root.querySelector('[data-suit-pants]');
      const total = root.querySelector('[data-suit-total]');
      const button = root.querySelector('[data-suit-submit]');
      const error = root.querySelector('[data-suit-error]');
      const update = () => {
        if (root.dataset.matchColor) {
          const color = jacket.selectedOptions[0].dataset.color;
          [...pants.options].slice(1).forEach((option) => {
            const matches = option.dataset.color === color;
            option.hidden = Boolean(color) && !matches;
            option.disabled = Boolean(color) && !matches;
          });
          if (color && pants.value && pants.selectedOptions[0].dataset.color !== color) pants.value = '';
        }
        const ready = Boolean(jacket.value && pants.value);
        button.disabled = !ready;
        total.textContent = ready ? new Intl.NumberFormat(document.documentElement.lang || 'en-CA', { style: 'currency', currency: 'CAD' }).format((Number(jacket.selectedOptions[0].dataset.price) + Number(pants.selectedOptions[0].dataset.price)) / 100) : 'Choose both sizes';
        error.hidden = true;
      };
      jacket.addEventListener('change', update);
      pants.addEventListener('change', update);
      button.addEventListener('click', async () => {
        if (!jacket.value || !pants.value) return;
        button.disabled = true;
        error.hidden = true;
        try {
          const response = await fetch(root.dataset.cartUrl + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: [{ id: Number(jacket.value), quantity: 1 }, { id: Number(pants.value), quantity: 1 }] }) });
          if (!response.ok) { const result = await response.json(); throw new Error(result.description || 'Unable to add the suit. Please try again.'); }
          window.location.assign(root.dataset.cartPage);
        } catch (failure) {
          error.textContent = failure.message || 'Unable to add the suit. Please try again.';
          error.hidden = false;
          button.disabled = false;
        }
      });
      update();
    });
  });
  } catch(e) { console.error(e); }
})();

})();
